import { render, staticRenderFns } from "./finishScreening.vue?vue&type=template&id=445f1296&scoped=true&"
import script from "./finishScreening.vue?vue&type=script&lang=js&"
export * from "./finishScreening.vue?vue&type=script&lang=js&"
import style0 from "./finishScreening.vue?vue&type=style&index=0&id=445f1296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445f1296",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
